import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PSIcon from '../../PSIcon';
import PSModal from '../../PSModal';
import { Button } from '../../atoms';
import { ButtonColor } from '../../atoms/button/Button';
import UserNetPrivada from '../../../shared/services/UserNetPrivada';

import './index.scss';

const RenovationActions = ({ dataPolicy, refreshProducts }) => {
  const { id } = useParams();
  const [loadingAction, setLoadingAction] = useState(false);
  const [showModalDisaffiliation, setShowModalDisaffiliation] = useState(false);
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const cancelRenewal = async () => {
    setLoadingAction(true);
    const response = await UserNetPrivada.cancelRenewalSoat(
      { 'customer-id': id },
      dataPolicy?.subscribedRenewalData?.idTokenizacion
    );
    if (response?.status?.id === 200) {
      await refreshProducts();
      setShowModalDisaffiliation(false);
      setShowModalConfirmation(true);
    } else {
      setShowModalDisaffiliation(false);
      setShowModalError(true);
    }
    setLoadingAction(false);
  };

  const maskCard = (value) => {
    if (!value) return '';
    const last4 = value.slice(-4);
    return '*'.repeat(Math.max(0, value.length - 4)) + last4;
  };

  const handleCancelClick = () => {
    setShowModalDisaffiliation(true);
  };

  const handleDetail = () => {
    setShowModalDetail(true);
  };

  const handleHideModal = () => {
    setShowModalDisaffiliation(false);
    setShowModalConfirmation(false);
    setShowModalError(false);
  };

  return (
    <>
      {loadingAction && (
        <div className="loading-action">
          <div className="loading-action__spinner" />
        </div>
      )}
      <div className="action-renovation">
        <div className="action-renovation__icons">
          <div
            title={dataPolicy?.subscribedRenewal ? 'Desafiliar Renovación Automática' : ''}
            onClick={() => {
              if (dataPolicy?.subscribedRenewal) {
                handleCancelClick();
              }
            }}
            className={!dataPolicy?.subscribedRenewal ? 'icon-disabled' : ''}
          >
            <PSIcon type="block" className="action-renovation__icons--block" />
          </div>

          {dataPolicy?.subscribedRenewalData?.idTokenizacion && (
            <div title="Ver detalle" onClick={() => handleDetail()}>
              <PSIcon type="searchOrange" className="action-renovation__icons--search" />
            </div>
          )}
        </div>

        {showModalDisaffiliation && (
          <PSModal
            open={showModalDisaffiliation}
            onClose={() => {
              setShowModalDisaffiliation(false);
            }}
            classNames="modal-disaffiliation"
          >
            <div className="action-renovation__modalDisaffiliation">
              <h2>Desafiliar renovación automática</h2>
              <p>¿Está seguro que desea desactivar la renovación automática de esta póliza?</p>
              <div className="action-renovation__modalDisaffiliation--buttons">
                <Button type={ButtonColor.orange} onClick={() => cancelRenewal()}>
                  Confirmar desafiliación
                </Button>
                <Button type={ButtonColor.orangeOutline} onClick={() => handleHideModal()}>
                  Cancelar
                </Button>
              </div>
            </div>
          </PSModal>
        )}

        {showModalConfirmation && (
          <PSModal
            open={showModalConfirmation}
            onClose={() => {
              setShowModalConfirmation(false);
            }}
            classNames="modal-confirmation"
          >
            <div className="action-renovation__modalConfirmation">
              <PSIcon type="checkCircle" className="action-renovation__modalConfirmation--icon" />
              <p>Desafiliación Exitosa</p>
              <div className="action-renovation__modalConfirmation--buttons">
                <Button type={ButtonColor.orange} onClick={() => handleHideModal()}>
                  OK
                </Button>
              </div>
            </div>
          </PSModal>
        )}

        {showModalError && (
          <PSModal
            open={showModalError}
            onClose={() => {
              setShowModalError(false);
            }}
            classNames="modal-error"
          >
            <div className="action-renovation__modalError">
              <PSIcon type="remove" className="action-renovation__modalError--icon" />
              <p>Ocurrió un error, volver a intentar</p>
              <div className="action-renovation__modalError--buttons">
                <Button type={ButtonColor.orange} onClick={() => handleHideModal()}>
                  Cerrar
                </Button>
              </div>
            </div>
          </PSModal>
        )}

        {showModalDetail && (
          <PSModal
            open={showModalDetail}
            onClose={() => {
              setShowModalDetail(false);
            }}
            classNames="modal-detail"
          >
            <div className="action-renovation__modalDetail">
              <h2>Detalle de la tarjeta</h2>
              <div className="action-renovation__modalDetail--table">
                <div className="table-header">
                  <div>Operador</div>
                  <div className="table-header__card">
                    <PSIcon type="cardOrange" className="table-header__card--icon" />
                    Tarjeta
                  </div>
                  <div>Fecha de afiliación</div>
                  <div>Fecha de desafiliación</div>
                </div>

                <div className="table-body">
                  <div>{dataPolicy?.subscribedRenewalData?.tipoTarjeta}</div>
                  <div>{maskCard(dataPolicy?.subscribedRenewalData?.numeroTarjeta)}</div>
                  <div>{dataPolicy?.subscribedRenewalData?.fechaInicioVigencia || ''}</div>
                  <div>{dataPolicy?.subscribedRenewalData?.fechaExpiracionToken || ''}</div>
                </div>
              </div>

              <div className="action-renovation__modalDetail--buttons">
                <Button type={ButtonColor.orange} onClick={() => setShowModalDetail(false)}>
                  OK
                </Button>
              </div>
            </div>
          </PSModal>
        )}
      </div>
    </>
  );
};

export default RenovationActions;
